import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReplaySubject, Subject } from 'rxjs';
import { debounceTime, delay, filter, map, takeUntil, tap } from 'rxjs/operators';
import { SolicitudAmpliacionSsoModel } from 'src/app/models/calendario-sso/SolicitudAmpliacionSsoModel';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { eTypeResult, TipoSolicitudAmpliacion } from 'src/app/models/common/enumModel';
import { ContratistaModel } from 'src/app/models/contratista/ContratistaModel';
import { FilterContratistaModel } from 'src/app/models/contratista/FilterContratistaModel';
import { FichaSsoModel } from 'src/app/models/ficha-sso/FichaSsoModel';
import { ISolicitudAmpliacionSsoModel } from 'src/app/models/interfaces/calendario-sso/ISolicitudAmpliacionSsoModel';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ContratistaService } from 'src/app/services/contratista/contratista.service';
import { SedeService } from 'src/app/services/sede/sede.service';
import { SolicitudAmpliacionSsoService } from 'src/app/services/solicitud-ampliacion-sso/solicitud-ampliacion-sso.service';
import { SsoSolicitarAmpliacionComponent } from '../sso-solicitar-ampliacion/sso-solicitar-ampliacion.component';

@Component({
  templateUrl: './sso-solicitar-nuevaempresa-dialog.component.html',
  styleUrls: ['./sso-solicitar-nuevaempresa-dialog.component.css']
})
export class SsoSolicitarNuevaempresaDialogComponent implements OnInit {
  model:ISolicitudAmpliacionSsoModel;
  listaContratistas: ContratistaModel[] = new Array<ContratistaModel>();
  listaSedes: ISedeModel[] = new Array<SedeModel>();

  
  public bankServerSideCtrl: FormControl = new FormControl();

  /** control for filter for server side. */
  public bankServerSideFilteringCtrl: FormControl = new FormControl();

  /** indicate search operation is in progress */
  public searching = false;

  /** list of banks filtered after simulating server side search */
  public  filteredServerSideBanks: ReplaySubject<ContratistaModel[]> = new ReplaySubject<ContratistaModel[]>(1);

  protected _onDestroy = new Subject<void>();


  constructor(public dialogRef: MatDialogRef<SsoSolicitarAmpliacionComponent>,
    private alertDialogService: AlertDialogService,
    private sedeService: SedeService,
    private dialogService: ConfirmDialogService,
    private contratistaService: ContratistaService,
    @Inject(MAT_DIALOG_DATA) public data: FichaSsoModel,
    private service: SolicitudAmpliacionSsoService) { 
      this.model = new SolicitudAmpliacionSsoModel();
      this.model.idCompania = data.idCompania;
      this.model.anio = data.anio;
      this.model.mes = data.mes;
      this.model.nombreMes = data.nombreMes;
      this.model.motivo;
    }

  ngOnInit(): void {
    const filterSede: IFilterSedeModel = new FilterSedeModel();

    this.sedeService
      .getList(filterSede)
      .subscribe((data: ISedeModel[]) => {
        this.listaSedes = data;
      });
    const contratistaFilter = new FilterContratistaModel();
      this.contratistaService
        .getList(contratistaFilter)
        .subscribe((data: ContratistaModel[]) => {        

          this.listaContratistas = data;

          this.bankServerSideCtrl.setValue(this.model.idContratista);//this.listaContratistas.find(bank => bank.idContratista === this.model.idContratista));

          var lista = data.filter(p => p.idContratista === this.model.idContratista);        
          this.filteredServerSideBanks.next(lista.slice());
        });

      // listen for search field value changes
      this.bankServerSideFilteringCtrl.valueChanges
      .pipe(
        filter(search => !!search),
        tap(() => this.searching = true),
        takeUntil(this._onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.listaContratistas) {
            return [];
          }

          // simulate server fetching and filtering data
          return this.listaContratistas.filter(bank => bank.nombre.toLowerCase().indexOf(search.toLowerCase()) > -1);
        }),
        delay(500),
        takeUntil(this._onDestroy)
      )
      .subscribe(filteredBanks => {
        this.searching = false;
        this.filteredServerSideBanks.next(filteredBanks);
      },
      error => {
        // no errors in our simulated example
        this.searching = false;
        // handle error...
      });  
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  
  onSubmit(form: NgForm) {
    
    if (!form.invalid) {      
      
      
      if (this.model.motivo == '') {
        this.alertDialogService.open('Debe ingresar el motivo de su solicitud');
      } else {
        this.dialogService.open('¿Seguro de enviar la solicitud?'); //options
          this.dialogService.confirmed().subscribe((confirmed) => {
            if (confirmed) { 
              this.model.idTipo = TipoSolicitudAmpliacion.NuevaEmpresa;
              if(this.model.idSedeSelected)
                this.model.idSede = this.model.idSedeSelected;
              this.service.submit(this.model).subscribe((result: ActionResultModel) => {
                console.log(result);
                if(result.type!=eTypeResult.SUCCESS){
                  this.alertDialogService.open(result.message);
                }else{
                  this.dialogRef.close(this.data);
                }
              });
            }
          });
        
      }
    }
  }
}
